/** Mirror of ObservableOperationLog.LogSeverity */
export const OPERATION_LOG_SEVERITY = {
    Info: 0,
    Warning: 1,
    Error: 2
};
